import axios from "axios";
import { API_BASE_URL1 } from "../Services/baseApiUrl";
import axiosInstance from "../../Hooks/axoisInstance";
const getToken = () => {
  return localStorage.getItem("token");
};

export const GetRoute = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetAllRoutes`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const AddRoute = async (routeData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `Routes/AddNewRoute`, routeData,
      // const response = await axios.post(API_BASE_URL + `route/create`, routeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
      });
    return response;
  } catch (error) {
    throw error;

  }
};

export const AddRouteDetails = async (routeData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + "Routes/AddRouteDetails",
      routeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const SaveRouteStoppage = async (stoppageData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + "Routes/SaveRouteStoppage",
      stoppageData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetRouteStoppages = async (routeId) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + `Routes/GetRouteStoppages?routeId=${routeId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const DeleteRouteStoppage = async (stoppageId) => {
  try {
    const response = await axiosInstance.delete(
      API_BASE_URL1 + `Routes/DeleteRouteStoppage?stoppageId=${stoppageId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const AssignVehicle = async (payload) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL1 + "Routes/AssignVehicle",
      payload,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const UpdateRoute = async (id, requestData) => {
  try {
    const response = await axiosInstance.put(API_BASE_URL1 + `Routes/UpdateRouteDetails`, requestData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
      });
    console.log(response, 'from api')
    return response;
  } catch (error) {
    throw error

  }
};

export const getRouteById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetRouteAndCollectionPointMapDetailsById?routeId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error

  }
};

export const GetRouteAndCollectionPointMapDetailsById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `Routes/GetRouteAndCollectionPointMapDetailsById?routeId=${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    return response;
  } catch (error) {
    throw error
  }
};

export const GetAllRouteDetails = async () => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 + "Routes/GetAllRouteDetails",
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};